import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    saveLocalCopy: string;
    saveLocation: string;
    selectLocation: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for saving a local copy */
            saveLocalCopy: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "LocalCopyRow.saveLocalCopy?c=1j6sp8dowrx2w", defaultMessage: "Save a Local Copy" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the local save location */
            saveLocation: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "LocalCopyRow.saveLocation?c=ia46if0sfe5j", defaultMessage: "Save Location" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label when no location is selected */
            selectLocation: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "LocalCopyRow.selectLocation?c=1gilr0if6ypxe", defaultMessage: "Select Location" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
